module.exports = "<iframe frameborder=\"0\" allowfullscreen width=\"100%\" height=\"100%\" src=\"{{ url }}\"></iframe>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/youtube/templates/youtube.html
// module id = 614
// module chunks = 0